
export default [
    {
        path: '/payment-statistics',
        name: 'payment-statistic',
        meta: { requiresAuth: true },
        component: () => import('@/pages/payment-statistic/index.vue')
    }
]